import { fromJS } from 'immutable';

import { collectionReducer } from 'utils/reducerGenerator';

const patchUserSuccess = (state, action) => {
    return state.set('data', state.get('data').map((user) => {
        if (user.get('id') === action.payload.data.id) {
            return fromJS(action.payload.data);
        }

        return user;
    }));
};
const toggleExpandUser = (state, action) => {
    const { id } = action;
    return state.setIn(['expanded', id], !state.getIn(['expanded', id], false));
};

export const { reducer, types } = collectionReducer(
    { namespace: 'USER' },
    {
        PATCH_USER_SUCCESS: patchUserSuccess,
        TOGGLE_EXPAND_USER: toggleExpandUser,
    }
);

export default reducer;
